module.exports = __webpack_public_path__ + "static/media/awwwards_nominee_white_left@2x.ba25cdaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/header/assets/awwwards_nominee_white_left@2x.png
// module id = 51
// module chunks = 0